import React from 'react';
import PropTypes from "prop-types";

export default function RightCaretSVG(props) {
  return (
    <svg 
      id={props.id || ''}
      className={props.className || ''}
      height={props.styles.height || '15px'}
      width={props.styles.width || '15px'}
      viewBox="0 0 32 32" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg">
      <g id="Icon/Arrow/Right" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path 
          fill={props.styles.fill} 
          d="M30.0026002,7 L34,10.7322932 L18.0104009,25.6614662 L18,25.651 L17.9895991,25.6614662 L2,10.7322932 L5.99739978,7 L17.999,18.207 L30.0026002,7 Z" 
          id="Shape" 
          transform="translate(18.000000, 16.330733) rotate(-90.000000) translate(-18.000000, -16.330733) "></path>
      </g>
    </svg>
  );
}

RightCaretSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};
